export default {
  data() {
    return {
    };
  },
  methods: {
    navigate(value) {
      switch (value) {
        case 'organize':
          this.$router.push('/organizer/effort');
          break;
        case 'tasks':
          this.$router.push('/effort');
          break;
        case 'messages':
          this.$router.push('/messages');
          break;
        case 'profile':
          this.$router.push('/profile');
          break;
        default:
          break;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/navigation.js